import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  InputAdornment,
  Button,
  Tabs,
  Tab,
  Box
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from '../components/LoadingButton'
import TableMui from '../components/TableMui'
import getTableOptions from '../constants/TableOptions'
import DialogTable from '../components/DialogTable'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { DashboardAthenaTableServerSideNoSelect } from '../components/DashboardAthenaTableServerSideNoSelect'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import TextField from '@material-ui/core/TextField'
import {
  employeeAbsencePlanDatesCols,
  useEmployeeAbsenceTransactionCols
} from '../constants/AbsenceManagementCols'
import { AntTabs } from '../components/VendorTabs'
import { debounce } from 'lodash'
import AbsenceManagementMain from '../components/AbsenceManagementMain'
import AthenaParameterTransformation from "../utils/AthenaParameterTransformation";
import fetchFromAthena from '../functions/FetchFromAthena'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
const _ = require('lodash')

const serversideEntriesPerPage = 50

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const defaultHeaders = {
  year: '',
  department: '',
  employeeId: '',
  absenceType: '',
  status: '',
  fromDate: '',
  toDate: '',
  includeInactive: 0
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`absence-tabpanel-${index}`}
      aria-labelledby={`absence-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `absence-tab-${index}`,
    'aria-controls': `absence-tabpanel-${index}`,
  };
}

export default function AbsenceManagement(props) {
  const [state, setState] = useState({
    options: null,
    isLoading: false,
    data: null,
    fetched: true,
    isServerSide: false,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [detailsInfo, setDetailsInfo] = useState(null)
  const [clearHeader, setClearHeaders] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [tableRefreshKey, setTableRefreshKey] = useState(0)
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false)
  const [absenceData, setAbsenceData] = useState({})
  const [isLoadingMainData, setIsLoadingMainData] = useState(false)
  const [company, setCompany] = useState('')
  const [employee, setEmployee] = useState('')
  const [clearTrigger, setClearTrigger] = useState(false)
  const classes = useStyles()
  
  const transactionCols = useEmployeeAbsenceTransactionCols()

  const { credentials } = props.fetchInitialData

  const handleClose = () => {
    setDetailsInfo(null)
  }

  // Create a debounced submit handler
  const debouncedSubmit = React.useCallback(
    debounce((e) => {
      setShowTable(true)
      setState(prevState => ({ ...prevState, tableKey: JSON.stringify(headers) }))
      setTableRefreshKey(prevKey => prevKey + 1)
      
      // Re-enable the button after 2 seconds
      setTimeout(() => {
        setIsSubmitDisabled(false)
      }, 2000)
    }, 300),
    [headers]
  )

  const handleSubmit = e => {
    e.preventDefault()
    if (!isSubmitDisabled) {
      setIsSubmitDisabled(true)
      setState(prevState => ({ ...prevState, isLoading: true }))
      debouncedSubmit(e)
      
      // Set loading state back to false after a short delay
      setTimeout(() => {
        setState(prevState => ({ ...prevState, isLoading: false }))
      }, 1000)
    }
  }

  const handleCallback = (values, error) => {
    if (error) {
      setState({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setState({ ...state, isLoading: false })
  }

  const viewDetails = async absenceId => {
    const resp = await LambdaFetch(
      'absence-management',
      'post',
      credentials.user.accessToken,
      JSON.stringify({
        action: 'get-absence-details',
        absenceId
      }),
      '',
      credentials
    )

    setDetailsInfo(resp.data.detailsData)
  }

  const tableDataTransformation = rows => {
    return rows
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Function to fetch data for the Main tab
  const fetchMainData = async () => {
    try {
      setIsLoadingMainData(true)



      const queries = ['employee_absence_plan']
      
      const data = await Promise.allSettled(
          queries.map(query =>
              fetchFromAthena({
                  queryName: query,
                  headers,
                  accessToken: credentials.user.accessToken,
                  credentials: credentials
              })
          )
      ).then(results => {
          return results
      })

      setAbsenceData(data?.[0]?.value?.[0] || {});
      setIsLoadingMainData(false)




      // const params = AthenaParameterTransformation('employee_absence_plan', headers)
      // const fetchBody = {
      //   dashboard_name: 'employee_absence_plan',
      //   ...params,
      //   pageSize: 1, // We only need one record for the main view
      //   roles: 'app_user,all-access,default',
      //   frontendTable: true
      // }
      
      // const resp = await LambdaFetch(
      //   'dashboard-trigger-temp-table',
      //   'post',
      //   props.fetchInitialData.credentials.user.accessToken,
      //   JSON.stringify(fetchBody),
      //   '',
      //   credentials
      // )
      
      // if (resp.data && resp.data.response && resp.data.response.data && resp.data.response.data.length > 0) {
      //   setAbsenceData(resp.data.response.data[0])
      // } else {
      //   setAbsenceData({})
      // }
      // setIsLoadingMainData(false)
    } catch (error) {
      console.error("Error fetching main data:", error)
      setAbsenceData({})
      setIsLoadingMainData(false)
    }
  }

  // Update useEffect to fetch data when the component mounts or when headers change
  useEffect(() => {
    if (showTable) {
      fetchMainData()
    }
  }, [showTable, tableRefreshKey])

  if (!state.fetched) {
    return <LoadingCircle />
  }

  const options = getTableOptions({
    cols: employeeAbsencePlanDatesCols,
    fileName: `Absence_Management`
  })
  options.downloadOptions.filterOptions.useDisplayedColumnsOnly = false

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <DialogTable
        isOpen={!!detailsInfo}
        handleClose={handleClose}
        tableData={detailsInfo}
        cols={employeeAbsencePlanDatesCols}
        simpleTable={true}
      />
      
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Absence Management
      </Typography>
      
      <div style={{ margin: '1rem' }}>
        <Paper style={{ padding: '1rem' }}>
          <form
            onSubmit={e => {
              e.preventDefault()
              handleSubmit(e)
            }}
          >
            <Grid
              container
              spacing={2}
              direction='row'
              justifyContent='flex-start'
              alignItems='center'
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='250px'
                  label='Company'
                  page="EMPLOYEE"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    const companyValue = val?.VALUE || null
                    setCompany(companyValue)
                    setHeaders({ ...headers, company: companyValue })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='employee'
                  required
                  disabled={!company}
                  width='300px'
                  label='Employee'
                  page="EMPLOYEE"
                  entity="EMPLOYEE"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    COMPANY: company
                  }}
                  onChange={(val) => {
                    const employeeValue = val?.VALUE || null
                    setEmployee(employeeValue)
                    setHeaders({ ...headers, employee: employeeValue })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='plan'
                  required
                  disabled={!company || !employee}
                  width='250px'
                  label='Plan'
                  page="ABSENCE"
                  entity="PLAN"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    COMPANY: company,
                    EMPLOYEE: employee
                  }}
                  onChange={(val) => {
                    const planValue = val?.VALUE || null
                    setHeaders({ ...headers, plan: planValue })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='structureGroup'
                  required
                  disabled={!company || !employee}
                  width='250px'
                  label='Employee Group'
                  page="ABSENCE"
                  entity="EMPLOYEEGROUP"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    COMPANY: company,
                    EMPLOYEE: employee
                  }}
                  onChange={(val) => {
                    const structureGroupValue = val?.VALUE || null
                    setHeaders({ ...headers, structureGroup: structureGroupValue })
                  }}
                />
              </Grid>
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
                disabled={isSubmitDisabled}
              />
              {!!(
                company ||
                employee ||
                headers.plan ||
                headers.structureGroup
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setCompany('')
                    setEmployee('')
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  {' '}
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem' }}>
            <Paper>
              <div style={{ padding: '1rem' }}>
                <AntTabs
                  value={tabValue}
                  handleChange={handleTabChange}
                  color="#1976d2"
                  tabs={[
                    "Main",
                    "Transactions"
                  ]}
                />
              </div>
              
              <TabPanel value={tabValue} index={0}>
                <AbsenceManagementMain data={absenceData} isLoading={isLoadingMainData} />
              </TabPanel>
              
              <TabPanel value={tabValue} index={1}>
              <DashboardAthenaTable
                  {...props}
                        isTempTable={false}
                        key={`transactions-${tableRefreshKey}`}
                        params={{ ...headers }}
                        tableColumns={transactionCols}
                        reportName='employee_absence_transaction'
                  />
              </TabPanel>
            </Paper>
          </div>
        )}
      </div>
    </div>
  )
}
